import React from 'react';

import { Container } from './styles';

interface Props {
    type: "success" | "danger";
}

const Message: React.FC<Props> = ({ children, type }) => {


    return <Container type={type}>{children}</Container>


}

export default Message;